var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',{attrs:{"title":"入库审核列表"}},[_c('template',{slot:"action"}),_c('a-card',[_c('expert-s-table',{ref:"expertSTable",attrs:{"from-type":_vm.ExpertFromType.STOCK_IN}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }